import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Landing mobile-first y corta: cada bloque avanza hacia la compra sin repetir
 * argumentos. Todo lo que está debajo del primer viewport se carga en diferido
 * para que el Hero (LCP) llegue con el menor JS posible.
 *
 * Recorrido: hero → problema/solución → biblioteca de 200 → qué podés fabricar
 * → 4 tomos → dentro de una fórmula → 5 bonos → oferta → FAQ → cierre.
 */
const ProblemSolutionSection = lazy(() => import('./components/ProblemSolutionSection').then(m => ({
  default: m.ProblemSolutionSection
})));
const LibrarySection = lazy(() => import('./components/LibrarySection').then(m => ({
  default: m.LibrarySection
})));
const VarietySection = lazy(() => import('./components/VarietySection').then(m => ({
  default: m.VarietySection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const FormulaSection = lazy(() => import('./components/FormulaSection').then(m => ({
  default: m.FormulaSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyBuyBar = lazy(() => import('./components/StickyBuyBar').then(m => ({
  default: m.StickyBuyBar
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-cream'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="st2k4mhw53ku" />} data-id="element-0" data-mp="stkj3qvxtvwg">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-cream pb-16 text-charcoal sm:pb-0" data-id="element-2" data-mp="3udaxmaph6r5r">
      <Hero data-id="element-3" data-mp="3uf5gljh6s977" />
      <Deferred minHeight="520px" background="bg-white" data-id="element-4" data-mp="d4e6dvbvvgxr">
        <ProblemSolutionSection data-id="element-5" data-mp="d3wd97kipiu2" />
      </Deferred>
      <Deferred minHeight="420px" background="bg-charcoal" data-id="element-6" data-mp="851kpdwr0fwr">
        <LibrarySection data-id="element-7" data-mp="83i2vivg1wsv" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-sand" data-id="element-8" data-mp="3gkv1zuywlvev">
        <VarietySection data-id="element-9" data-mp="3gja7u6gi4ehj" />
      </Deferred>
      <Deferred minHeight="420px" data-id="element-10" data-mp="3bmtgz4hx3m0r">
        <TomosSection data-id="element-11" data-mp="3bnuwbl5yuuoa" />
      </Deferred>
      <Deferred minHeight="420px" background="bg-white" data-id="element-12" data-mp="3qb7k7gj8xchu">
        <FormulaSection data-id="element-13" data-mp="3qcqyj1lcddgz" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-sand" data-id="element-14" data-mp="3lkhfm5in9do7">
        <BonosSection data-id="element-15" data-mp="3liwlgh08rwqv" />
      </Deferred>
      <Deferred minHeight="640px" data-id="element-16" data-mp="2xuwtjdr720ap">
        <OfferSection data-id="element-17" data-mp="2xtv6eawwlncm" />
      </Deferred>
      <Deferred minHeight="520px" data-id="element-18" data-mp="2xsseq0rrbgvn">
        <FaqSection data-id="element-19" data-mp="2swbtbebxzgm9" />
      </Deferred>
      <Deferred minHeight="320px" background="bg-white" data-id="element-20" data-mp="2svah36j6wo2y">
        <FinalCta data-id="element-21" data-mp="18e171cv5hagc" />
      </Deferred>
      <Deferred minHeight="300px" background="bg-sand" data-id="element-22" data-mp="18czoknbt1lol">
        <Footer data-id="element-23" data-mp="1d47xli983518" />
      </Deferred>
      <Suspense fallback={null} data-id="element-24" data-mp="1d5j8e2135d1u">
        <StickyBuyBar data-id="element-25" data-mp="1d6kpan4s8trh" />
      </Suspense>
    </main>;
}